import { COMPANY, SOCIALS } from '../constants/company'
import { useLanguage } from '../context/LanguageContext'

const NAVY = '#0d1d3a'
const TEXT_MUTED = 'rgba(255,255,255,0.55)'
const TEXT_WHITE = '#ffffff'
const FONT = "'Poppins', sans-serif"

function Footer() {
  const { t } = useLanguage()
  return (
    <div style={{ backgroundColor: NAVY, width: '100%', color: TEXT_WHITE }}>
      <style>{`
        .footer-link { text-decoration: none; color: rgba(255,255,255,0.75); font-family: ${FONT}; font-size: 14px; font-weight: 400; transition: color 0.2s; }
        .footer-link:hover { color: #ffffff; }
        .footer-icon-link { color: rgba(255,255,255,0.7); font-size: 17px; text-decoration: none; transition: color 0.2s; -webkit-tap-highlight-color: transparent; }
        .footer-icon-link:hover, .footer-icon-link:active, .footer-icon-link:focus { color: #C5A059; outline: none; }
        .footer-contact-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; padding-bottom: 30px; }
        .footer-links-grid { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 40px; padding-bottom: 30px; }
        .footer-headline { font-size: clamp(22px, 3vw, 32px); }
        @media (max-width: 900px) {
          .footer-contact-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-links-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          .footer-contact-grid { grid-template-columns: 1fr !important; }
          .footer-links-grid { grid-template-columns: 1fr !important; }
          .footer-headline { font-size: 22px !important; }
        }
      `}</style>

      <div style={{ maxWidth: '1300px', margin: '0 auto', padding: '0 20px', boxSizing: 'border-box' }}>

        {/* ── TOP HEADLINE ── */}
        <div style={{ padding: '50px 0 35px 0' }}>
          <p className="footer-headline" style={{
            fontFamily: FONT,
            fontWeight: 600,
            lineHeight: '1.25em',
            color: TEXT_WHITE,
            margin: 0,
            maxWidth: '700px',
          }}>
            { t('footer.headline') }
          </p>
        </div>

        {/* ── CONTACT ROW ── */}
        <div className="footer-contact-grid">
          {/* Contact */}
          <div>
            <h3 style={{ fontFamily: FONT, fontSize: '13px', fontWeight: 500, color: TEXT_MUTED, margin: '0 0 10px 0', textTransform: 'none' }}>
              <a href={`mailto:${COMPANY.email}`} className="footer-link" style={{ color: TEXT_MUTED }}>{ t('footer.letsWork') }</a>
            </h3>
            <p style={{ fontFamily: FONT, fontSize: '14px', lineHeight: '1.8em', color: 'rgba(255,255,255,0.75)', margin: 0 }}>
              <span style={{ color: TEXT_MUTED }}>{ t('footer.email') }: </span>
              <a href={`mailto:${COMPANY.email}`} style={{ color: TEXT_WHITE, textDecoration: 'none' }}>{COMPANY.email}</a><br />
              <span style={{ color: TEXT_MUTED }}>{ t('footer.callWhatsApp') }: </span>
              <a href={`https://wa.me/${COMPANY.whatsapp.replace(/\s/g, '')}`} style={{ color: TEXT_WHITE, textDecoration: 'none' }}>{COMPANY.whatsapp}</a>
            </p>
          </div>

          {/* Our location */}
          <div>
            <h3 style={{ fontFamily: FONT, fontSize: '13px', fontWeight: 500, color: TEXT_MUTED, margin: '0 0 10px 0' }}>
              { t('footer.ourLocation') }
            </h3>
            <p style={{ fontFamily: FONT, fontSize: '14px', lineHeight: '1.8em', color: 'rgba(255,255,255,0.75)', margin: '0 0 12px 0' }}>
              {COMPANY.location}
            </p>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '5px', padding: '4px 10px',
                fontFamily: FONT, fontSize: '12px', fontWeight: 600, color: '#C5A059',
              }}>DED : 685655</span>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '5px', padding: '4px 10px',
                fontFamily: FONT, fontSize: '12px', fontWeight: 600, color: '#C5A059',
              }}>RERA : 12084</span>
            </div>
          </div>

          {/* Office Phone */}
          <div>
            <h3 style={{ fontFamily: FONT, fontSize: '13px', fontWeight: 500, color: TEXT_MUTED, margin: '0 0 10px 0' }}>
              <a href={`tel:${COMPANY.phone.replace(/\s/g, '')}`} className="footer-link" style={{ color: TEXT_MUTED }}>{ t('footer.officePhone') }</a>
            </h3>
            <p style={{ fontFamily: FONT, fontSize: '14px', lineHeight: '1.8em', color: 'rgba(255,255,255,0.75)', margin: 0 }}>
              {COMPANY.phone}
            </p>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginBottom: '35px' }} />

        {/* ── LINKS ROW ── */}
        <div className="footer-links-grid">
          {/* Company info */}
          <div>
            <p style={{ fontFamily: FONT, fontSize: '15px', fontWeight: 600, color: TEXT_WHITE, margin: '0 0 14px 0' }}>
              {COMPANY.name}
            </p>
            <p style={{ fontFamily: FONT, fontSize: '13px', lineHeight: '1.7em', color: TEXT_MUTED, margin: '0 0 24px 0', maxWidth: '340px' }}>
              { t('footer.tagline') }
            </p>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '5px', padding: '4px 10px',
                fontFamily: FONT, fontSize: '12px', fontWeight: 600, color: '#C5A059',
              }}>DED : 685655</span>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: '5px',
                background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '5px', padding: '4px 10px',
                fontFamily: FONT, fontSize: '12px', fontWeight: 600, color: '#C5A059',
              }}>RERA : 12084</span>
            </div>
          </div>

          {/* Our Services */}
          <div>
            <p style={{ fontFamily: FONT, fontSize: '15px', fontWeight: 600, color: TEXT_WHITE, margin: '0 0 14px 0' }}>
              { t('footer.ourServices') }
            </p>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {t('footer.serviceLinks').map(item => (
                <li key={item}><a href="#" className="footer-link">{item}</a></li>
              ))}
            </ul>
          </div>

          {/* Useful Links */}
          <div>
            <p style={{ fontFamily: FONT, fontSize: '15px', fontWeight: 600, color: TEXT_WHITE, margin: '0 0 14px 0' }}>
              { t('footer.usefulLinks') }
            </p>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {t('footer.serviceLinks').map(item => (
                <li key={item}><a href="#" className="footer-link">{item}</a></li>
              ))}
            </ul>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginBottom: '20px' }} />

        {/* ── COPYRIGHT & SOCIAL ROW ── */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: '28px',
          flexWrap: 'wrap',
          gap: '16px',
        }}>
          <div style={{ fontFamily: FONT, fontSize: '13px', color: TEXT_MUTED }}>
            {COMPANY.copyright}
          </div>

          {/* Social icons */}
          <div style={{ display: 'flex', flexDirection: 'row', gap: '18px', alignItems: 'center' }}>
            <a href={SOCIALS.facebook} target="_blank" rel="noreferrer" aria-label="facebook" className="footer-icon-link">
              <i className="fab fa-facebook-f" />
            </a>
            <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" aria-label="instagram" className="footer-icon-link">
              <i className="fab fa-instagram" />
            </a>
            <a href={SOCIALS.linkedin} target="_blank" rel="noreferrer" aria-label="linkedin" className="footer-icon-link">
              <i className="fab fa-linkedin-in" />
            </a>
            <a href={SOCIALS.x} target="_blank" rel="noreferrer" aria-label="x" className="footer-icon-link">
              <i className="fa-brands fa-x-twitter" />
            </a>
            <a href={SOCIALS.youtube} target="_blank" rel="noreferrer" aria-label="youtube" className="footer-icon-link">
              <i className="fab fa-youtube" />
            </a>
            <a href={SOCIALS.tiktok} target="_blank" rel="noreferrer" aria-label="tiktok" className="footer-icon-link">
              <i className="fab fa-tiktok" />
            </a>
            <a href={`https://wa.me/${COMPANY.whatsapp.replace(/\s/g, '')}`} target="_blank" rel="noreferrer" aria-label="whatsapp" className="footer-icon-link">
              <i className="fab fa-whatsapp" />
            </a>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Footer
